var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "设置主管",
        visible: _vm.visibleDialogSetManager,
        "before-close": _vm.visiClose,
        width: "800px"
      }
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            {
              staticStyle: {
                "margin-top": "-15px",
                "padding-right": "0",
                "text-align": "end"
              },
              attrs: { span: 24 }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    model: _vm.setManagerFilters,
                    size: "small"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { placeholder: "姓名" },
                        model: {
                          value: _vm.setManagerFilters.keyword,
                          callback: function($$v) {
                            _vm.$set(_vm.setManagerFilters, "keyword", $$v)
                          },
                          expression: "setManagerFilters.keyword"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        { on: { click: _vm.handleClickSearchManager } },
                        [_vm._v("查询")]
                      ),
                      _c("el-button", { on: { click: _vm.reset } }, [
                        _vm._v("重置")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "custom-table-style",
              staticStyle: { "margin-top": "-15px" },
              attrs: { span: 24 }
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: {
                    width: "100%",
                    border: "1px solid #cbcbcb",
                    "border-bottom": "0"
                  },
                  attrs: {
                    data: _vm.tableSetManager,
                    "tooltip-effect": "dark",
                    "highlight-current-row": "",
                    "header-cell-style": {
                      background: "#f9f9f9",
                      color: "#333333",
                      fontWeight: "600"
                    }
                  },
                  on: { "row-click": _vm.handleClickRow }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "姓名/企业名称",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.userName) +
                                "\n            "
                            ),
                            scope.row.targetId != ""
                              ? _c("span", [
                                  _vm._v(_vm._s("(" + scope.row.targetId + ")"))
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "部门",
                      prop: "groupNames",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { width: "50" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.selectCorpUserId ===
                                      scope.row.corpUserId,
                                    expression:
                                      "selectCorpUserId === scope.row.corpUserId"
                                  }
                                ]
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/images/check.png",
                                    alt: "",
                                    width: "25"
                                  }
                                })
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "page-flex-end",
              staticStyle: { padding: "30px 0", position: "relative" },
              attrs: { span: 24 }
            },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.setManagerFilters.itemPage,
                  "page-sizes": [5, 10, 20, 50, 100],
                  "page-size": _vm.setManagerFilters.pageSize,
                  layout: "sizes, prev, pager, next, total",
                  total: _vm.setManagerFilters.pageTotal
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              }),
              _c("el-go", {
                attrs: {
                  "page-size": _vm.setManagerFilters.pageSize,
                  total: _vm.setManagerFilters.pageTotal
                },
                on: { "current-change": _vm.handleCurrentChange }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { color: "#ec1c1c" },
              attrs: { type: "text" },
              on: { click: _vm.cancelManager }
            },
            [_vm._v("移除当前部门主管")]
          ),
          _c(
            "el-button",
            { attrs: { size: "mini" }, on: { click: _vm.visiClose } },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: {
                click: function($event) {
                  return _vm.handleClickSetManagerOk()
                }
              }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76877944", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76877944","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/console/memberManage/components/supervisor.vue
// module id = kGnX
// module chunks = 7 40